'use strict';

const Backbone = require('backbone');
const CounterView = require('communication/ui/counter/counter');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');

module.exports = CounterView.extend({
    initialize: function () {
        this.model = new Backbone.Model({});

        const project = this.getOption('project');
        const key = this.getOption('key');
        // オプション未指定のときには、念の為リクエスト発行して件数を取得する
        const hasTask = this.getOption('hasTask') == null ? true : this.getOption('hasTask');

        const unreadIndicatorDisabled = this.getOption('unreadIndicatorDisabled');
        const unreadIndicatorEnabled = !unreadIndicatorDisabled;

        const onLoaded = (tasks) => {
            this.model.set('badge', {
                content: function () {
                    return tasks.getTotalCount();
                },
                hasUnread: function() {
                    return unreadIndicatorEnabled && tasks.hasUnfinishedTask();
                },
                listen: function (onChange) {
                    tasks.on('change:totalCount', onChange);
                }
            });

            this.listenBadgeChange();
            this.onChangeBadge();
        };

        if (hasTask) {
            TaskCollectionRepository
                .find(project)
                .byKey(key)
                .fetchFirstPage()
                .then(onLoaded);
        } else {
            TaskCollectionRepository
                .find(project)
                .byKey(key)
                .buildEmptyPage()
                .then(onLoaded);
        }
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/counter.js